import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { URLConst } from 'src/app/shared/const/url.const';
import { EnvironmentconfigService } from '../../../shared/service/environmentconfig.service';
import { WebApiService } from '../../../shared/service/webapi.service';
import { BaseComponent } from 'src/app/shared/base/base.component';


@Component({
  selector: 'app-AddProxy-Single',
  templateUrl: './AddProxy-Single.component.html'
})

export class AddProxySingleComponent extends BaseComponent implements OnInit {
  @Input() isAdd: boolean = false;
  @Input() isEdit: boolean = false;
  @Input() editData: any;
  @Output() close = new EventEmitter<any>();
  @Output() save = new EventEmitter<any>();
  @Output() Cancel = new EventEmitter<any>();

  loading: boolean = false;
  OldProxyID: string;
  OldStartDate: any;
  OldEndDate: any;
  pageIndex: number = 1;
  listOfData: any[] = [];
  pageSize: number = 20;
  isCancel: boolean = false;
  nzTotal: number = 0;
  dateNow: any = this.getTheDateStringforMMDD();
  str: string;
  tabIndex: number = 0;
  Function: any;
  @Input() set index(value) {
    if (!!value || value === 0) {
      this.tabIndex = value;
    }
  };

  constructor(private authService: AuthService,
    private webApiService: WebApiService,
    private messageService: NzMessageService,
    private EnvironmentconfigService: EnvironmentconfigService) { super(); }

  ngOnInit() {
    this.getResultData();
  }

  nzPageSizeChange(event: number): void {
    if (this.nzTotal === 0) {
      return;
    }
    this.pageSize = event;
    if (event * this.pageIndex > this.nzTotal && this.pageIndex > 1) {
      this.pageIndex--;
    }
    this.getResultData();
  }

  nzPageIndexChange(event: number): void {
    this.pageIndex = event;
    this.getResultData();
  }

  OnAdd() {
    this.isAdd = true;
  }

  closeAdd() {
    this.isAdd = false;
    this.isEdit = false;
  }

  submitForm = ($event: any, value: any) => {
    $event.preventDefault();
    for (const key in this.validateForm.controls) {
      this.validateForm.controls[key].markAsDirty();
      this.validateForm.controls[key].updateValueAndValidity();
    }
    let obj = {};
    obj['StartDate'] =
      this.getTheDateString_(this.validateForm.controls['StartDate'].value) ||
      '';
    obj['EndDate'] =
      this.getTheDateString_(this.validateForm.controls['EndDate'].value) || '';
    obj['EmployeeID'] = this.validateForm.controls['EmployeeID'].value;
    obj['ProxyID'] = this.validateForm.controls['ProxyID'].value;

    obj['Remark'] =
      this.validateForm.controls['Remark'].value == null
        ? ''
        : this.validateForm.controls['Remark'].value;
    obj['OldProxyID'] = this.OldProxyID;
    obj['OldStartDate'] = this.getTheDateString_(this.OldStartDate);
    obj['OldEndDate'] = this.getTheDateString_(this.OldEndDate);
    obj['PoNo'] = this.validateForm.controls['PoNo'].value;
    if (!this.isCancel) {
      this.save.emit(obj);
    }
    else {
      this.Cancel.emit(obj);
    }
  };

  getResultData() {
    this.loading = true;
    const url = `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.GetProxyHistory.url}`;
    const params = {
      pageSize: this.pageSize,
      pageIndex: this.pageIndex,
      data: {
        EmployeeID: (this.authService.getCurrentUserInfo()?.userId ?? ''),
        HavePono: false

      },
    };
    this.webApiService.doPost(url, params).subscribe(
      (res) => {
        if (res && res.status == this.EnvironmentconfigService.authConfig.wmsmStatus) {
          this.listOfData = res.data.map((item) => {
            item.startDate = this.getTheDateString_(item.startDate);
            item.endDate = this.getTheDateString_(item.endDate);
            return item;
          });
          this.nzTotal = res.total;
        } else {
          this.listOfData = [];
          this.nzTotal = 0;
          this.messageService.warning(res.msg);
        }
        this.loading = false;
      },
      (error) => {
        this.messageService.error(error.msg);
      }
    );
  }

  saveAdd(event) {
    this.SaveNew(
      `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.AddOneProxy.url}`,
      event
    );
  }

  SaveNew(url, data) {
    this.loading = true;
    const params = {
      data: {
        EmployeeID: data.EmployeeID,
        ProxyID: data.ProxyID,
        Function: data.Function,
        StartDate: this.getTheDateString_(data.StartDate),
        EndDate: this.getTheDateString_(data.EndDate),
        Remark: data.Remark || '',
      },
    };
    this.webApiService.doPost(url, params).subscribe((res) => {
      if (res && res.status == this.EnvironmentconfigService.authConfig.wmsmStatus) {
        this.messageService.success(res.msg);
        this.getResultData();
        this.isAdd = false;
      } else {
        this.messageService.error(res.msg);
      }
      this.loading = false;
    });
  }

  onEdit(data) {
    this.editData = { ...data };
    this.isEdit = true;
  }

  saveEdit(event) {
    this.editData = null;
    this.modifyData(
      `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.EditProxyEndDate.url}`,
      event
    );
  }

  modifyData(url, data) {
    this.loading = true;
    const params = {
      data: {
        EmployeeID: data.EmployeeID,
        ProxyID: data.ProxyID,
        Function: data.ProxyFunction,
        Pono: data.PoNo,
        StartDate: this.getTheDateString_(data.StartDate),
        EndDate: this.getTheDateString_(data.EndDate),
        OldProxyID: data.OldProxyID,
        OldStartDate: this.getTheDateString_(data.OldStartDate),
        OldEndDate: this.getTheDateString_(data.OldEndDate),
        Remark: data.Remark || '',
        ProxyName: data.ProxyName
      },
    };
    this.webApiService.doPost(url, params).subscribe((res) => {
      if (res && res.status == this.EnvironmentconfigService.authConfig.wmsmStatus) {
        this.messageService.success(res.msg);
        this.getResultData();
        this.isEdit = false;
      } else {
        this.messageService.error(res.msg);
      }
      this.loading = false;
    });
  }

  GetCancelFlag(value) {
    this.cancelData(
      `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.CancelProxy.url}`, value);
  }

  cancelData(url, data) {
    this.loading = true;
    const params = {
      data: {
        EmployeeID: data.EmployeeID,
        ProxyID: data.ProxyID,
        ProxyFunction: data.ProxyFunction,
        StartDate: this.getTheDateString_(data.StartDate),
        Pono: data.PoNo
      },
    };
    this.webApiService.doPost(url, params).subscribe((res) => {
      if (res && res.status == this.EnvironmentconfigService.authConfig.wmsmStatus) {
        this.messageService.success(res.msg);
        this.getResultData();
        this.isEdit = false;
      } else {
        this.messageService.error(res.msg);
      }
      this.loading = false;
    });
  }




}
